// extracted by mini-css-extract-plugin
export default {"navItem":"NavLinks_navItem__TSCnj"};